<div *ngIf="!isDvi2Enabled" class="inspection-card">
  <!-- Card Header -->
  <div class="inspection-card-header flex-between-center">
    <!-- Card Header Headings -->
    <div class="inspection-card-heading flex-center-start flex-column">
      <span class="font-12">
        {{ inspection.title }}
      </span>
      <span class="font-10">
        {{ categoryCount }} categories {{ inspectionItemCount }} items
      </span>
    </div>

    <!-- Card Header Actions -->
    <div class="inspection-card-action">
      <div class="flex-start-center">
        <!-- <div *ngIf="inspection?.tech?.techId" class="font-12 mr-4 font-primary">
          {{renderStatus()}}
        </div> -->

        <!-- Inspection Select Technician -->
        <div class="mr-2">
          <!-- <app-dropdown [hidden]="inspectionStatus === 'inprogress'" hPosition="left"
            listHeaderTitle="Select Technician" scrollHeight="150px" itemWidth="180px" [options]="technicians"
            [isDropdownIconVisible]="false" [focusOnSelectedValue]="false" [hasCustomOpenTemplate]="true"
            [hasCustomItemTemplate]="true" [hasListHeader]="true" (appSelect)="selectTechnicianForInspection($event)">

            <ng-template let-item appTemplate="open-dropdown-btn">
              <div class="flex-start-center" [hidden]="inspection?.tech?.techId">
                <span class="font-12 mr-2">
                  Assign technician
                </span>
                <i class="fal fa-plus bg-white border-circle font-15 p-2 add-tech flex-center-center"></i>
              </div>
              <span [title]="inspection?.tech?.name" [hidden]="!inspection?.tech?.techId"
                class="initials-padding bg-white border-circle font-10 flex-center-center">
                {{helperService.fetchInitials(inspection?.tech?.name)}}
              </span>
            </ng-template>

            <ng-template let-item appTemplate="item">
              <div class="flex-start-center flex-row">
                <span *ngIf="!item.isUnassignOption"
                  class="initials-padding bg-body border-circle font-10 mr-2 flex-center-center">
                  {{renderInitials(item)}}
                </span>
                <span class="font-10" *ngIf="!item.isUnassignOption"
                  [ngClass]="{'font-bold': inspection?.tech?.techId && inspection?.tech?.techId === item._id}">{{item.firstName}}
                  {{item.lastName}}</span>
                <span *ngIf="item.isUnassignOption"
                  class="initials-padding bg-body border-circle font-10 mr-2 flex-center-center">
                  <i class="fal fa-user-hard-hat font-gray"></i>
                </span>
                <span class="font-10" *ngIf="item.isUnassignOption"
                  [ngClass]="{'font-bold': !inspection?.tech?.techId}">Unassigned</span>
              </div>
            </ng-template>
          </app-dropdown> -->
          <!-- <span [title]="inspection?.tech?.name"
            class="initials-padding bg-white border-circle font-10 p-2 add-tech mr-2 flex-center-center border-radius not-allowed">
            {{helperService.fetchInitials(inspection?.tech?.name)}}
          </span> -->
        </div>
        <!-- Start Inspection Delete Icon -->
        <!-- <span class="mr-2 pr-2">
          <i class="fas fa-trash pointer" (click)="deleteCompleteInspectionConfirm()"></i>
        </span> -->
      </div>
    </div>
  </div>

  <!-- Start Inspections Accordian Section -->
  <div class="inspection-accordian-section">
    <!-- Inspection Accordian Header -->
    <div class="inspection-accordian-heading font-14 p-2 pl-4">
      Inspection Checklist
    </div>

    <!-- Inspection Accordian -->
    <div>
      <app-accordian *ngFor="let category of inspection?.category; let categoryIndex = index" listItemIdKey="itemId"
        headerLabel="title" headerCountLabel="items" listItemKey="inspectionItems" listItemLabel="title"
        [data]="category" [hasCustomSelectedItemText]="false" [iconSize]="10" [fontSize]="12" [showSelectedItem]="true"
        [index]="categoryIndex" [hasCustomHeader]="true" [hasAccordianSubItem]="true"
        [hasAccordianSubItemCheckbox]="false">
        <!-- Start Accordian Custom Header -->
        <ng-template appTemplate="accordian-header">
          <div class="flex-between-center">
            <!-- Accordian Header Left -->
            <span class="font-12">{{category?.title}}</span>
            <!-- Accordian Header Right -->
            <div class="flex-start-center">
              <!-- Technician Name -->
              <!-- <span class="font-12 mr-1">
                {{( category?.tech?.techId)? category?.tech?.name: 'Assign Technician'}}
              </span> -->
              <!-- Select Technician Dropdown -->
              <div class="mr-2">
                <!-- <app-dropdown listHeaderTitle="Select Technician" hPosition="left" scrollHeight="150px"
                  itemWidth="180px" [options]="technicians" [isDropdownIconVisible]="false"
                  [focusOnSelectedValue]="false" [hasCustomOpenTemplate]="true" [hasCustomItemTemplate]="true"
                  [hasListHeader]="true" (appSelect)="selectTechnicianForCategory($event, categoryIndex)">

                  <ng-template let-item appTemplate="open-dropdown-btn">
                    <i class="fal fa-plus bg-body border-circle font-15 p-2 add-tech flex-center-center"
                      [hidden]="category?.tech?.techId"></i>
                    <span [hidden]="!category?.tech?.techId"
                      class="initials-padding bg-body border-circle font-10 mr-2 flex-center-center">
                      {{helperService.fetchInitials(category?.tech?.name)}}
                    </span>
                  </ng-template>

                  <ng-template let-item appTemplate="item">
                    <div class="flex-start-center flex-row">
                      <span class="initials-padding bg-body border-circle font-10 mr-2 flex-center-center">
                        {{renderInitials(item)}}
                      </span>
                      <span class="font-10">{{item.firstName}} {{item.lastName}}</span>
                    </div>
                  </ng-template>
                </app-dropdown> -->
              </div>
              <!-- Total Items Count -->
              <div class="font-12 item-width mr-4">
                {{category?.inspectionItems?.length}} items
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Start Accordian Sub Item -->
        <ng-template let-item let-inspectionItemIndex="index" appTemplate="accordian-sub-item">
          <div class="ui-g inspection-item-action default-cursor">

            <div class="ui-g-3 p-0 flex-start-center">
              <div class="font-12 font-600">{{item.title}}</div>
            </div>

            <div class="ui-g-5 p-0 flex-start-center"></div>

            <!-- <div class="ui-g-4 p-0 flex-center-center"> -->
            <div class="ui-g-4 p-0 flex-end-center">
              <div class="ui-g">
                <div class="ui-g-10 flex-center-center">
                  <!-- <div (click)="selectColorState(0, inspectionItemIndex, categoryIndex)"
                    [ngClass]="{'not-allowed': inspectionStatus === 'inprogress'}"
                    [ngStyle]="{'background-color': (item.colorIndex === 0) ? colors[0].value: '#fff'}"
                    class="color-circle pointer color1"></div>
                  <div (click)="selectColorState(1, inspectionItemIndex, categoryIndex)"
                    [ngClass]="{'not-allowed': inspectionStatus === 'inprogress'}"
                    [ngStyle]="{'background-color': (item.colorIndex === 1) ? colors[1].value: '#fff'}"
                    class="color-circle pointer color2"></div>
                  <div (click)="selectColorState( 2, inspectionItemIndex, categoryIndex)"
                    [ngClass]="{'not-allowed': inspectionStatus === 'inprogress'}"
                    [ngStyle]="{'background-color': (item.colorIndex === 2) ? colors[2].value: '#fff'}"
                    class="color-circle pointer color3"></div> -->
                  <div [ngClass]="{'not-allowed': true}"
                    [ngStyle]="{'background-color': (item.colorIndex === 0) ? colors[0].value: '#fff'}"
                    class="color-circle pointer"></div>
                  <div [ngClass]="{'not-allowed': true}"
                    [ngStyle]="{'background-color': (item.colorIndex === 1) ? colors[1].value: '#fff'}"
                    class="color-circle pointer"></div>
                  <div [ngClass]="{'not-allowed': true}"
                    [ngStyle]="{'background-color': (item.colorIndex === 2) ? colors[2].value: '#fff'}"
                    class="color-circle pointer"></div>
                </div>

                <div class="ui-g-2 attachment-icon-wrapper">
                  <!-- <app-content-overlay [closeOnClickOutside]="true">
                    <ng-template appTemplate="item">
                      <i class="fal fa-sticky-note pointer"
                        [ngClass]="{'font-light': item.attachments.length === 0, 'font-primary': item.attachments.length || item.notes}"></i>
                    </ng-template>
                    <ng-template appTemplate="overlay" let-close="close">
                      <app-inspection-item-notes [inspectionStatus]="inspectionStatus" [inspectionItem]="item"
                        [close]="close" (appSave)="saveAttachment($event)" (appClose)="close()">
                      </app-inspection-item-notes>
                    </ng-template>
                  </app-content-overlay> -->
                </div>

                <!-- <div class="ui-g-1 delete-inspection"> <i
                    (click)="removeInspectionItemConfirm(categoryIndex, inspectionItemIndex)"
                    class="fas fa-trash delete-inspection-icon pointer font-gray"></i>
                </div> -->
              </div>
            </div>
          </div>
        </ng-template>
      </app-accordian>
    </div>
  </div>
</div>

<div *ngIf="isDvi2Enabled" class="mb-3 inspection-checklist">
  <div class="inspection-header flex-between-center">

    <div class="d-flex">
      <i class="fal fa-ballot-check font-gray-45 align-self-center"></i>
      <span class="font-bold m-0 ml-2 inspection-name" tooltipPosition="top"
        [pTooltip]="inspection?.inspectionId.title">{{
        inspection?.inspectionId.title }}</span>
      <span class="ml-3 mr-1">&#8213;</span>
      <span
        class="font-13 font-600 align-self-center px-2">{{renderCategoriesAndItems(inspection?.inspectionId)}}</span>

        <span [ngClass]="{
          'todo-tag': inspection?.inspectionId?.inspectionStatus === 'todo',
          'in-progress-tag': inspection?.inspectionId?.inspectionStatus === 'inProgress',
          'completed-tag': inspection?.inspectionId?.inspectionStatus === 'completed'
        }">{{statusMapper(inspection?.inspectionId?.inspectionStatus)}}</span>

      <div class="flex-start-center" tooltipPosition="top"
        pTooltip="{{counts?.condition?.notInspected}} / {{counts?.items}} are not filled">
        <div class="inspection-condition-circle item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.notInspected}}</p>
      </div>

      <!-- Bad Condition -->
      <div class="flex-start-center" tooltipPosition="top"
        pTooltip="{{counts?.condition?.bad}} / {{counts?.items}} are marked Red">
        <div class="inspection-condition-circle bad item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.bad}}</p>
      </div>

      <!-- Normal Condition -->
      <div class="flex-start-center" tooltipPosition="top"
        pTooltip="{{counts?.condition?.normal}} / {{counts?.items}} are marked Yellow">
        <div class="inspection-condition-circle normal item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.normal}}</p>
      </div>

      <!-- Good Condition -->
      <div class="flex-start-center" tooltipPosition="top"
        pTooltip="{{counts?.condition?.good}} / {{counts?.items}} are marked Green">
        <div class="inspection-condition-circle good item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.good}}</p>
      </div>
    </div>

    <div class="d-flex">
      <div class="multi-tech-assignment flex-start-center" [ngClass]="{ 'not-allowed': estimate.isArchived }">
        <span *ngIf="!service?.tech?.techId" class="font-600 mr-2">Assign&nbsp;technician</span>

        <div *ngIf="service?.tech?.techId" [id]="'tech-'+ service?.tech?.techId + '-' + service._id"
          (click)="toggleTechCard(service?.tech?.techId, 'tech')"
          class="tech-assign-circle flex-center-center mr-2 primary-tech {{ service?.tech?.workStatus }}"
          [ngClass]="cardId === 'tech'  &&  isTechnicianDetailsVisible ? 'active' : ''" tooltipPosition="top"
          [pTooltip]="service?.tech?.tooltip" [escape]="false">
          <span class="initial font-bold">{{ techInitials[service?.tech?.techId]?.initials }}</span>
          <img class="work-state-icon" [src]="workStateIconSolid[service?.tech?.workStatus]"
            [alt]="workStateTitle[service?.tech?.workStatus]" />
        </div>

        <div *ngIf="service?.hTechOne?.techId" [id]="'tech-'+ service?.hTechOne?.techId + '-' + service._id"
          (click)="toggleTechCard(service?.hTechOne?.techId, 'hTechOne')"
          class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechOne?.workStatus }}" tooltipPosition="top"
          [ngClass]="cardId === 'hTechOne'  &&  isTechnicianDetailsVisible  ? 'active' : ''"
          [pTooltip]="service?.hTechOne?.tooltip" [escape]="false">
          <span class="initial font-600">{{ techInitials[service?.hTechOne?.techId]?.initials }}</span>
          <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechOne?.workStatus]"
            [alt]="workStateTitle[service?.hTechOne?.workStatus]" />
        </div>

        <div *ngIf="service?.hTechTwo?.techId" [id]="'tech-'+ service?.hTechTwo?.techId + '-' + service._id"
          (click)="toggleTechCard(service?.hTechTwo?.techId , 'hTechTwo')"
          class="tech-assign-circle flex-center-center mr-2 {{ service?.hTechTwo?.workStatus }}" tooltipPosition="top"
          [ngClass]="cardId === 'hTechTwo' &&  isTechnicianDetailsVisible ? 'active' : ''"
          [pTooltip]="service?.hTechTwo?.tooltip" [escape]="false">
          <span class="initial font-600">{{ techInitials[service?.hTechTwo?.techId]?.initials }}</span>
          <img class="work-state-icon" [src]="workStateIconSolid[service?.hTechTwo?.workStatus]"
            [alt]="workStateTitle[service?.tech?.workStatus]" />
        </div>

        <i class="fal fa-plus add-tech flex-center-center font-gray p-2"
          [ngClass]="{ 'not-allowed': estimate.isArchived }" (click)="handleOpenTechDialog()"
          [hidden]="service?.tech?.techId && service?.hTechOne?.techId && service?.hTechTwo?.techId">
        </i>
      </div>

      <div class="flex-center-center height-42 bborder service-ddl"
        [ngClass]="{ 'disabled-dropdown-option': estimate.isArchived }">
        <app-dropdown itemWidth="180px" scrollHeight="150px" hPosition="left" styleClassSelectedView="p-0"
          [disabled]="estimate.isArchived" [options]="serviceActions" [isDropdownIconVisible]="false"
          [hasCustomOpenTemplate]="true" [hasCustomItemTemplate]="true" (appSelect)="handleServiceAction($event)">
          <ng-template let-item appTemplate="open-dropdown-btn">
            <i class="fas fa-ellipsis-v font-gray-35 p-2"></i>
          </ng-template>

          <ng-template let-item appTemplate="item">
            <div class="d-flex">
              <i [class]="item.icon + ' pr-2 align-self-center'"></i>
              <span [class]="item.color">{{item.name}}</span>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
    </div>
  </div>

  <div class="inspection-body">
    <button class="btn btn-view-inspection" (click)="handleOpenInspection()">
      <span class="font-14">View Inspection</span>
    </button>
  </div>
</div>